import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    voiceUrl: String,
    localUserId: Number,
    senderId: Number,
    enabled: Boolean
  }

  connect() {
    this.handleMuteChanged = this.handleMuteChanged.bind(this)
    this.handleUserGesture = this.handleUserGesture.bind(this)
    window.addEventListener("voice-skins:mute-changed", this.handleMuteChanged)
    document.addEventListener("click", this.handleUserGesture, true)
    document.addEventListener("keydown", this.handleUserGesture, true)
    document.addEventListener("touchstart", this.handleUserGesture, true)

    this.playIfApplicable()
  }

  disconnect() {
    window.removeEventListener("voice-skins:mute-changed", this.handleMuteChanged)
    document.removeEventListener("click", this.handleUserGesture, true)
    document.removeEventListener("keydown", this.handleUserGesture, true)
    document.removeEventListener("touchstart", this.handleUserGesture, true)
    this.teardownAudio()
  }

  playIfApplicable() {
    const url = this.voiceUrlValue
    if (!url) {
      console.warn("🔇 No voice URL present for playback.")
      return
    }

    if (this.localUserIdValue === this.senderIdValue) {
      return
    }

    this.teardownAudio()

    const audio = new Audio(url)
    this.audio = audio
    audio.volume = 1.0
    audio.muted = this.readMutePreference()
    audio.addEventListener("ended", () => this.teardownAudio(), { once: true })

    this.attemptPlayback()
  }

  handleMuteChanged(event) {
    const muted = !!event.detail?.muted
    if (this.audio) {
      this.audio.muted = muted
      if (!muted) {
        this.attemptPlayback()
      }
    }
  }

  handleUserGesture() {
    if (!this.audio || this.readMutePreference()) {
      return
    }

    this.attemptPlayback()
  }

  readMutePreference() {
    try {
      return localStorage.getItem("voiceSkinsMuted") === "true"
    } catch {
      return false
    }
  }

  teardownAudio() {
    if (!this.audio) {
      return
    }

    this.audio.pause()
    this.audio = null
  }

  attemptPlayback() {
    if (!this.audio || this.readMutePreference()) {
      return
    }

    this.audio.play()
      .then(() => {
        console.log(`🔊 Playing voice for user ${this.localUserIdValue}`)
      })
      .catch((err) => {
        console.warn("🔈 Voice playback deferred until user interaction:", err)
      })
  }
}
